// Import helper lib module
import * as lib from './lib';
// Importing sample JSON data for the state

// Action to fetch resources and set in state through the mutation
export const fetchResources = ({ commit }) => {
    commit('setResources', []);
};

// Action to add title grid item in the state through the mutation
export const addLinkGridItem = ({ commit, state }, payload) => {
    let g = lib.guid();
    let k = {
        x: 3,
        y: state.resources.length + 12,
        w: 6,
        h: 1,
        i: g,
        type: 'link',
    };
    commit('setNewGridItem', k);
};

// Action to add content grid item in the state through the mutation
export const addContentGridItem = ({ commit, state }, payload) => {
    let g = lib.guid();
    let k = {
        x: 0,
        y: state.resources.length + 12,
        w: 12,
        h: 4,
        i: g,
        type: 'content',
        content: 'Content goes here',
    };
    commit('setNewGridItem', k);
};

// Action to add image grid item in the state through the mutation
export const addImageGridItem = ({ commit, state }, payload) => {
    let g = lib.guid();
    let k = {
        x: 3,
        y: state.resources.length + 12,
        w: 6,
        h: 2,
        i: g,
        type: 'image',
    };
    commit('setNewGridItem', k);
};

// Action to remove item from the state through the mutation
export const removeItem = ({ commit, state }, payload) => {
    commit('removeItem', payload);
};

// Action to save updated headings through the mutation
export const saveHeadings = ({ commit, state }, payload) => {
    let currentItem = state.resources[payload.itemIndex];
    currentItem.headings.h1 = payload.values[0];
    currentItem.headings.h2 = payload.values[1];
    currentItem.headings.h3 = payload.values[2];
    commit('setUpdatedItem', {
        itemIndex: payload.itemIndex,
        item: currentItem,
    });
};

// Action to save item through the mutation
export const saveItem = ({ commit, state }, payload) => {
    commit('setUpdatedItem', payload);
};
